<app-mainmenu class="mainmenu"></app-mainmenu>
<div class="mainbody">
    <router-outlet></router-outlet>
</div>